import axios, { AxiosInstance } from 'axios';
import { appConfig } from '../services/config.service';

export const HttpClient = (): AxiosInstance => {
    const instance: AxiosInstance = axios.create({
        baseURL: appConfig.API_URL,
    });

    let token = localStorage.getItem('auth0token');

    if (token) {
        instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    return instance;
};

